<template>
  <div>
    <div
      id="covidStatusInfoModal"
      class="modal fade"
      tabindex="-1"
      role="dialog"
    >
      <div
        class="modal-dialog"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              Help
            </h4>
          </div>
          <div class="modal-body">
            <p>
              <b>Lockdown:</b> This indicates when hard lockdown is in place.
              Even when not, there will still be social distancing restrictions
              in place.
            </p>
            <p>
              <b>Social distancing:</b> The safe social distancing rules for
              public transport and workplaces vary over time. This indicator
              shows how severe the current restrictions are.
            </p>
            <p>
              <b>Public confidence:</b> This can be low, when people behave very
              cautiously, medium or high, when they make choices more or less as
              normal.
            </p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as $ from "jquery";
import "bootstrap";

export default {
  created() {
    this.$root.$data.eventHub.$on(
      "show-covidstatusinfo-modal",
      this.displayModal
    );
  },
  methods: {
    displayModal: function() {
      $("#covidStatusInfoModal").modal("show");
    }
  }
};
</script>

<style lang="scss">
#covidStatusInfoModal {
  .modal-body li {
    list-style-type: none;
    margin: 10px 0;
    padding: 0;
  }
  .modal-body ul {
    margin: 0;
    padding: 0;
  }
  .modal-body p {
    margin: 20px 0;
    text-align: justify;
  }
}
</style>
